import { Box, MenuList, Portal, StyleProps } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

import { useMenuSize } from '@bonusly/ds-hooks';
import { rem } from '@bonusly/ds-utils';

import { useIntersectionObserver } from '../../../hooks/use-intersection-observer';
import { useDropdownContext } from '../lib/context';

export interface DropdownMenuProps extends StyleProps, PropsWithChildren {}

export const DropdownMenu: FC<DropdownMenuProps> = ({ children, ...rest }) => {
	const { onScrollToBottom } = useDropdownContext();
	const ref = useMenuSize();

	const enableObserver = !!onScrollToBottom;

	const { rootRef, targetRef } = useIntersectionObserver({
		enabled: enableObserver,
		onEnterIntersection: onScrollToBottom,
	});

	return (
		<Portal>
			<MenuList
				ref={(el) => {
					ref(el);
					rootRef(el);
				}}
				zIndex="dropdown"
				{...rest}
			>
				<Box maxH={rem(360)} overflowY="auto">
					{children}
					{!!enableObserver && <div ref={targetRef} style={{ height: rem(1) }} />}
				</Box>
			</MenuList>
		</Portal>
	);
};
